import { useEffect } from 'react';

// Demo-only display fonts. Loaded lazily on demo pages (not in index.html) so
// the marketing pages stay lean — they only need Inter + Space Grotesk. Covers
// every `fontDisplay` used in src/data/demos.js, including Barlow Condensed.
const DEMO_FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@500;600;700&family=Bebas+Neue&family=Caveat:wght@500;600;700&family=Cormorant+Garamond:wght@400;500;600;700&family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600;9..144,700&family=Manrope:wght@500;600;700;800&display=swap';

export default function useDemoFonts() {
  useEffect(() => {
    if (document.getElementById('sudco-demo-fonts')) return;
    const link = document.createElement('link');
    link.id = 'sudco-demo-fonts';
    link.rel = 'stylesheet';
    link.href = DEMO_FONTS_HREF;
    document.head.appendChild(link);
  }, []);
}
